import axios from 'axios';
import router from '@/router';

const AxiosService = {
    init() {
        if (process.env.NODE_ENV === 'development') {
            axios.defaults.baseURL = `http://localhost:3000`;
        } else {
            axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        }

        axios.defaults.headers.common.Accept = 'application/json';
        axios.defaults.headers.common['Content-Type'] = 'application/json';

        axios.interceptors.response.use(
            response => response,
            (error) => {
                if (error.response.status === 401 && router.currentRoute.name !== 'Login') {
                    console.log("401 unauthorized");
                } else if (error.response.status === 404) {
                    console.log("404, not found");
                } else if (error.response.status === 500 && Object.prototype.hasOwnProperty.call(error.response, 'data')) {
                    console.error(error.response.data.error, error.response.data);
                }
                return Promise.reject(error);
            },
        );
    },
};

export default AxiosService; // export axios instance to be imported in your app
